<template>
  <hooper
    :progress="true"
    :autoPlay="true"
    :playSpeed="6500"
    :itemsToShow="1.35"
    :centerMode="true"
    :infiniteScroll="true"
    :wheelControl="false"
    :mouseDrag="true"
    :settings="hooperSettings"
    class="home-slider"
  >
    <slide v-for="item in items" :key="item.id">
      <router-link :to="item.value.type == 'spot' ? '/spots/' + item.value.meta.slug : '/tours/' + item.value.meta.slug">
        <img :src="baseUrl + item.value.thumb.src" :alt="item.value.title" class="card-img-top" />
        <div class="overray-content is-rounded">
          <div class="label" :class="'is-'+item.value.type">{{item.value.type}}</div>
          <h2 class="title">{{item.value.title}}</h2>
          <div class="summary">{{item.value.summary}}</div>
          <div v-if="item.value.type == 'tour'" class="duration"><span class="icon-access_time"></span>{{ $t("time_title") }}{{item.value.duration}}{{ $t("time_unit") }}</div>
        </div>
      </router-link>
    </slide>
    <hooper-pagination slot="hooper-addons"></hooper-pagination>
  </hooper>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      hooperSettings: {
        wheelControl: false,
        breakpoints: {
          1216: {
            itemsToShow: 2.1,
          },
          0: {

          }
        },
        windowHeight: 0,
        slideHeight: 0,
      }
    }
  },

  components: {
    Hooper,
    Slide,
    HooperPagination,
  },

  mounted() {
    // console.log(process.env.VUE_APP_BASE_URL)
    // console.log(process.env.VUE_APP_ROOT_API)
  }
}
</script>
<style lang="sass">
.hooper
  &.home-slider
    height: 0
    margin-top: 15px
    margin-bottom: 50px
    padding-top: 50%
    overflow: visible
    @media screen and (min-width:1216px)
      padding-top: 32.35%
    .hooper-list
      position: absolute
      top: 0
      left: 0
      overflow: visible
      .hooper-slide
        padding: 0 3.5%
        color: $white
        @media screen and (min-width:1216px)
          padding: 0 2%
        &.is-current
          transform: scale(1.1)
        a
          position: relative
          display: flex
          height: 100%
          flex-direction: column
          justify-content: center
          align-items: center
          img
            width: 100%
            border-radius: 5px
    .hooper-pagination
      bottom: -25px
      .hooper-indicator
        width: 7px
        height: 7px
        border-radius: 50%
        margin: 0 5px
        background-color: #BFBFBF
        &.is-active
          background-color: #E23C30
</style>
